import React, { FC } from 'react';

import { SearchDescription, SearchTitle } from '~/components/Hero/style';
import useIsSsku from '~/hooks/tenant/useIsSsku';

interface CategoryInfoProps {
  title?: string | null;
  description?: string | null;
}

export const CategoryInfo: FC<CategoryInfoProps> = ({ title, description }) => {
  const isSsku = useIsSsku();

  return (
    <>
      {title && (
        <SearchTitle special={isSsku} data-testid="categoryTitle" variant="h2">
          {title}
        </SearchTitle>
      )}
      {description && (
        <SearchDescription data-testid="categoryDescription">{description}</SearchDescription>
      )}
    </>
  );
};
